import * as Mustache from 'mustache';
import {
    addCommasToNumber,
    format_price
} from "../utils";
import * as Solr from './Solr';

export const StatsTable = (function() {
    const TYPE = {
        noData: 'no_data',
        parent: 'parent',
        listing: 'listing',
        part: 'part'
    };

    const LINK_TYPE = {
        title: 'title',
        wts: 'wts',
        wtb: 'wtb',
        parts: 'parts'
    };

    function formatNumber(value) {
        if (!value) {
            return '-';
        }

        return addCommasToNumber(value);
    }

    function formatPrice(value) {
        if (!value) {
            return '-';
        }

        return '$' + format_price(value);
    }

    var exports = {};

    exports.data = {
        filters: {},
        group_by: '',
        rows: {},
        no_data_element: null,
    };

    exports.internal = {
        solr_field: {
            part: '',
            listing: ''
        },
        url_key: {
            part: '',
            listing: ''
        },
        additional_url_params: {
            part: '',
            listing: ''
        }
    };

    exports.aggregate_data = {};

    exports.grand_totals = {};

    exports.populate = function(data) {

        StatsTable.data = $.extend(true, StatsTable.data, data);
        StatsTable.parseFields('solr_field');
        StatsTable.parseFields('url_key');
        StatsTable.parseFields('additional_url_params');

        var group_by = StatsTable.data.group_by;
        var group_title = StatsTable.data.group_title;

        if (StatsTable.data.filters.hasOwnProperty('type')) {
            delete StatsTable.data.filters.type;
        }

        if (StatsTable.data.filters.hasOwnProperty('target_type')) {
            delete StatsTable.data.filters.target_type;
        }

        if (!StatsTable.data.no_data_element) {
            StatsTable.data.no_data_element = $('#stats_table_no_data');
        }

        var filter_str_listings = _data.parseFilterParams(StatsTable.data.filters, 'listing');
        var filter_str_parts = _data.parseFilterParams(StatsTable.data.filters, 'part');

        filter_str_parts.push("displays_to_non_members:true");

        var facetListingsJson = {
            results: {
                type: "terms",
                field: group_by,
                limit: 1000,
                sort: {q: "desc"},
                facet: {
                    wtb: {
                        type: 'terms',
                        field: group_by,
                        limit: 1000,
                        domain: {filter: ["subject_typeid:1"]},
                        facet: {
                            xp: "max(price)",
                            mp: "avg(retail_price_aggregates)",
                            mpa: "min(retail_price_aggregates)",
                            q: "sum(quantity)",
                            s: "unique(userid)"
                        }
                    },
                    wts: {
                        type: 'terms',
                        field: group_by,
                        limit: 1000,
                        domain: {filter: ["subject_typeid:2"]},
                        facet: {
                            xp: "max(price)",
                            mp: "avg(retail_price_aggregates)",
                            mpa: "min(retail_price_aggregates)",
                            q: "sum(quantity)",
                            s: "unique(userid)"
                        }
                    },
                    xp: "max(price)",
                    mp: "avg(retail_price_aggregates)",
                    mpa: "min(retail_price_aggregates)",
                    q: "sum(quantity)",
                    s: "unique(userid)"
                }
            }
        };


        var facetPartsJson = {
            results: {
                type: "terms",
                field: group_by,
                limit: 1000,
                sort: {q: "desc"},
                facet: {
                    xp: "max(price)",
                    mp: "avg(retail_price_aggregates)",
                    mpa: "min(retail_price_aggregates)",
                    q: "sum(quantity)",
                    s: "unique(userid)"
                }
            }
        };

        StatsTable.facetRunner(filter_str_listings, facetListingsJson, StatsTable.data.group_by, function(listing_data) {
            StatsTable.facetRunner(filter_str_parts, facetPartsJson, StatsTable.data.group_by, function(parts_data) {
                listing_data.forEach((listing_row) => {
                    var key = '';

                    if (listing_row.hasOwnProperty('object') && listing_row.object.hasOwnProperty(group_title)) {
                        key = listing_row.object[group_title];
                    } else {
                        key = 'Unspecified';
                    }

                    StatsTable.aggregate_data[key] = {
                        group: {
                            title: key,
                            showTitleLink: true,
                            titleLink: StatsTable.generateLink(listing_row.object, StatsTable.data.url_endpoint, key !== 'Unspecified'?TYPE.listing:TYPE.noData, LINK_TYPE.title),
                            isGroup: true
                        },
                        listings: [],
                        parts: {
                            title: 'Inventory',
                            showTitleLink: true,
                            titleLink: StatsTable.generateLink(listing_row.object, StatsTable.data.url_endpoint, key !== 'Unspecified'?TYPE.part:TYPE.noData, LINK_TYPE.parts),
                            isGroup: false,
                            count: '-',
                            quantity: '-',
                            min_price: '-',
                            median_price: '-',
                            max_price: '-',
                            num_sellers: '-'
                        }
                    };

                    StatsTable.populate_listing_row(key, LINK_TYPE.wts, listing_row);
                    StatsTable.populate_listing_row(key, LINK_TYPE.wtb, listing_row);
                });

                parts_data.forEach((parts_row) => {

                    var key = '';

                    if (parts_row.hasOwnProperty('object') && parts_row.object.hasOwnProperty(group_title)) {
                        key = parts_row.object[group_title];
                    } else {
                        key = 'Unspecified';
                    }

                    if (!StatsTable.aggregate_data[key]) {
                        StatsTable.aggregate_data[key] = {
                            group: {
                                title: key,
                                showTitleLink: true,
                                titleLink: StatsTable.generateLink(parts_row.object, StatsTable.data.url_endpoint, key !== 'Unspecified'?TYPE.listing:TYPE.noData, LINK_TYPE.title),
                                isGroup: true
                            },
                            listings: [],
                            parts: {
                                title: 'Parts',
                                showTitleLink: true,
                                titleLink: StatsTable.generateLink(parts_row.object, StatsTable.data.url_endpoint, key !== 'Unspecified'?TYPE.part:TYPE.noData, LINK_TYPE.parts),
                                isGroup: false,
                                count: '-',
                                quantity: '-',
                                min_price: '-',
                                median_price: '-',
                                max_price: '-',
                                num_sellers: '-'
                            }
                        };

                        if (parts_row.hasOwnProperty('object') && parts_row.object.hasOwnProperty(group_title)) {
                            StatsTable.aggregate_data[key].group.title = parts_row.object[group_title];
                        } else {
                            StatsTable.aggregate_data[key].group.title = 'Undefined';
                        }
                    }

                    StatsTable.aggregate_data[key].parts = {
                        title: 'Inventory',
                        titleLink: StatsTable.generateLink(parts_row.object, StatsTable.data.url_endpoint, key !== 'Unspecified'?TYPE.part:TYPE.noData, LINK_TYPE.parts),
                        isGroup: false,
                        showTitleLink: true,
                        count: formatNumber(parts_row.count),
                        quantity: formatNumber(parts_row.q),
                        num_sellers: formatNumber(parts_row.s),
                        min_price: formatPrice(parts_row.mpa),
                        max_price: formatPrice(parts_row.xp),
                        median_price: formatPrice(parts_row.mp)
                    };

                });

                var row_keys = Object.keys(StatsTable.aggregate_data);
                row_keys.sort();
                var rows = [];
                row_keys.forEach((k) => {
                    if (k != 'Unspecified') {
                        rows.push(StatsTable.aggregate_data[k].group);
                        StatsTable.aggregate_data[k].listings.forEach((l) => {
                            rows.push(l);
                        });
                        rows.push(StatsTable.aggregate_data[k].parts);
                    }

                });
                if (StatsTable.aggregate_data['Unspecified']) {
                    rows.push(StatsTable.aggregate_data['Unspecified'].group);
                    StatsTable.aggregate_data['Unspecified'].listings.forEach((l) => {
                        rows.push(l);
                    });
                    rows.push(StatsTable.aggregate_data['Unspecified'].parts);
                }

                StatsTable.data.rows = rows;
                StatsTable.draw();
            });
        });

    };

    exports.parseFields = function (field) {
        if (StatsTable.data[field] && StatsTable.data[field] !== '') {
            var parts = StatsTable.data[field].split('|');
            StatsTable.internal[field].listing = parts[0];
            if (parts[1]) {
                StatsTable.internal[field].part = parts[1];
            } else {
                StatsTable.internal[field].part = parts[0];
            }
        }
    }

    exports.generateLink = function(object, endpoint, type, link_type) {
        var str = '/p' + _data.generateUrl(object, {endpoint: endpoint});

        if (link_type !== LINK_TYPE.title) {
            str += '/' + link_type;
        }

        if (type === TYPE.parent) {
            if (StatsTable.data.parent_keys) {
                StatsTable.data.parent_keys.forEach(function (row, i) {
                    var url_key = row.url;
                    var solr_key = row.solr;
                    var solr_field_value = object[solr_key];
                    str += (i === 0 ? '?' : '&') + url_key + '=' + solr_field_value;
                });
            }
        } else if(type === TYPE.noData) {
            if (StatsTable.data.parent_keys) {
                StatsTable.data.parent_keys.forEach(function (row, i) {
                    var url_key = row.url;
                    var solr_key = row.solr;
                    var solr_field_value = object[solr_key];
                    str += (i === 0 ? '?' : '&') + url_key + '=' + solr_field_value;
                });
            }
            let url_key = StatsTable.internal.url_key['listing'];
            str += '&'+url_key+'=unspecified';

        } else {
            let url_key = StatsTable.internal.url_key[type];
            let solr_key = StatsTable.internal.solr_field[type];
            let solr_field_value = object[solr_key];
            let additional_params = StatsTable.internal.additional_url_params[type];
            str += '?'+url_key+'='+solr_field_value+(additional_params !== ''?('&'+additional_params):'');
        }

        if (link_type !== LINK_TYPE.title) {
            str += '&type=' + link_type;
        }

        return str;
    }

    exports.populate_listing_row = function(key, field, row) {

        var titles = {
            wtb: {
                title: 'WTB'
            },
            wts: {
                title: 'WTS'
            }
        }

        if (row[field]) {
            if (row[field].buckets && row[field].buckets[0]) {
                var bucket = row[field].buckets[0];
                StatsTable.aggregate_data[key].listings.push({
                    title: titles[field] ? titles[field].title : '',
                    showTitleLink: true,
                    titleLink: StatsTable.generateLink(row.object, StatsTable.data.url_endpoint, key !== 'Unspecified'?TYPE.listing:TYPE.noData, field),
                    isGroup: false,
                    count: formatNumber(bucket.count),
                    quantity: formatNumber(bucket.q),
                    num_sellers: formatNumber(bucket.s),
                    min_price: formatPrice(bucket.mpa),
                    max_price: formatPrice(bucket.xp),
                    median_price: formatPrice(bucket.mp)
                });
            }

        }

    }

    exports.facetRunner = function(filter_str, facetJson, group_by, cb) {
        var resultSet = [];
        var facetJsonString = JSON.stringify(facetJson)

        let query = Solr.Model.searchRaw('*:*');
        if(filter_str) {
            filter_str.forEach((str)=>{
                query.whereRaw(str);
            });
        }
        query.facet(facetJson)
            .groupBy(group_by)
            .orderBy('price','ASC')
            .get(1000,1)
            .then((r)=>{
                var groupObj = {};
                if (r.hasOwnProperty('grouped') && r.grouped.hasOwnProperty(group_by)) {
                    r.grouped[group_by].groups.forEach(function(f) {
                        if (f.doclist.docs.length > 0) {
                            groupObj[f.groupValue] = f.doclist.docs[0];
                        }
                    });
                }

                if (r.hasOwnProperty('facets') && r.facets.hasOwnProperty('results') && r.facets.results.buckets.length > 0) {
                    r.facets.results.buckets.forEach(function(b) {
                        var data = b;
                        data.object = groupObj[b.val];
                        resultSet.push(data);
                    });
                }

                cb(resultSet);
            })
            .catch((e) => {
                console.error('Stats table facetRunner error:', e);
            });
        /*
        framework.get(url("api/search/listings"), {
            search: '*:*',
            start: 0,
            rows: 1000,
            filters: filter_str,
            facetjson: facetJsonString,
            sort: ['price:ASC'],
            group: [group_by]
        }, function(r) {

            var groupObj = {};
            if (r.hasOwnProperty('grouped') && r.grouped.hasOwnProperty(group_by)) {
                r.grouped[group_by].groups.forEach(function(f) {
                    if (f.doclist.docs.length > 0) {
                        groupObj[f.groupValue] = f.doclist.docs[0];
                    }
                });
            }

            if (r.hasOwnProperty('facets') && r.facets.hasOwnProperty('results') && r.facets.results.buckets.length > 0) {
                r.facets.results.buckets.forEach(function(b) {
                    var data = b;
                    data.object = groupObj[b.val];
                    resultSet.push(data);
                });
            }

            cb(resultSet);
        });

         */
    }

    exports.draw = function() {

        if (StatsTable.data.rows.length > 0) {
            StatsTable.data.no_data_element.hide();

            var stats_table_template = $('#stats_table_template').html();
            Mustache.parse(stats_table_template);   // optional, speeds up future uses

            var render_data = {
                tableTitle: 'Stats',
                rows: StatsTable.data.rows
            }

            var rendered = Mustache.render(stats_table_template, render_data);
            StatsTable.data.container.html(rendered);
        } else {
            StatsTable.data.no_data_element.show();
        }
    };

    return exports;
})();